import type {
  Faro,
  ReactRouterV6CreateRoutesFromChildren,
  ReactRouterV6MatchRoutes,
} from "@grafana/faro-react";
import {
  getWebInstrumentations,
  initializeFaro as coreInit,
  ReactIntegration,
  ReactRouterVersion,
} from "@grafana/faro-react";
import { TracingInstrumentation } from "@grafana/faro-web-tracing";
import {
  createRoutesFromChildren,
  matchRoutes,
  Routes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

export function initializeFaro(): Faro {
  const faro = coreInit({
    url: process.env.REACT_APP_FARO_URL,
    apiKey: process.env.REACT_APP_FARO_API_KEY,

    trackWebVitalsAttribution: true,
    instrumentations: [
      ...getWebInstrumentations({
        captureConsole: true,
      }),

      new TracingInstrumentation(),
      new ReactIntegration({
        router: {
          version: ReactRouterVersion.V6,
          dependencies: {
            createRoutesFromChildren:
              createRoutesFromChildren as ReactRouterV6CreateRoutesFromChildren,
            matchRoutes: matchRoutes as ReactRouterV6MatchRoutes,
            Routes,
            useLocation,
            useNavigationType,
          },
        },
      }),
    ],
    app: {
      name: "orchestrator-reference-app",
      namespace: "orchestrator-reference-app",
      version: "1.0.0",
      // environment: env.mode.name,
    },
  });

  faro.api.pushLog(["Faro was initialized ORCH"]);

  return faro;
}
